module.exports = __webpack_public_path__ + "static/img/product_3_1.30e2ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_3_1.png
// module id = PN9a
// module chunks = 34